import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import nProgress from 'nprogress'
const title = config.title

let kc = new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页', keepAlive: true
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: title + '-产品介绍', keepAlive: true
          },
          children: [
            {
              path: '/software',
              redirect: '/software/newMedia'
            },
            // {
            //   path: '/software',
            //   redirect: '/software/smartTown'
            // },
            {
              path: '/software/newMedia',
              name: 'software',
              component: resolve => require(['@/view/Software_newMedia'], resolve),
              meta: {
                title: '产品介绍丨新媒体', keepAlive: true
              }
            },
            {
              path: '/software/rightShoping',
              name: 'software',
              component: resolve => require(['@/view/Software_rightShoping'], resolve),
              meta: {
                title: '产品介绍丨权益商城', keepAlive: true
              }
            },
            {
              path: '/software/reductionActive',
              name: 'software',
              component: resolve => require(['@/view/Software_reductionActive'], resolve),
              meta: {
                title: '产品介绍丨立减金活动', keepAlive: true
              }
            },
            {
              path: '/software/supplyChain',
              name: 'software',
              component: resolve => require(['@/view/Software_supplyChain'], resolve),
              meta: {
                title: '产品介绍丨供应链金融', keepAlive: true
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: title + '-相关服务', keepAlive: true
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-新闻动态', keepAlive: true
          }
        }, {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情', keepAlive: true
          }
        }, , {
          path: '/informationCenter',
          name: 'informationCenter',
          component: resolve => require(['@/view/informationCenter'], resolve),
          meta: {
            title: title + '-新闻资讯', keepAlive: true
          }
        }, {
          path: '/informationCenterDetail',
          name: 'informationCenterDetail',
          component: resolve => require(['@/view/informationCenterDetail'], resolve),
          meta: {
            title: title + '-资讯详情', keepAlive: true
          }
        }, {
          path: '/aboutUs',
          name: 'aboutUs',

          component: resolve => require(['@/view/About_Us'], resolve),
          meta: {
            title: title + '-关于我们', keepAlive: true
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          // component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍', keepAlive: true
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          // component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: title + '-工作机会', keepAlive: true
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们', keepAlive: true
          }
        },
        {
          path: '/carService',
          name: 'carService',
          component: resolve => require(['@/view/carService'], resolve),
          meta: {
            title: title + '-车主服务', keepAlive: true
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'], resolve),
          meta: {
            title: title + '-相关服务', keepAlive: true
          }
        }
      ]
    }
  ]
})

kc.beforeEach((to, from, next) => {
  NProgress.start()
  localStorage.setItem('currentPath', window.location.pathname)
  next()
})

kc.afterEach(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  NProgress.done()
})
export default kc


// WEBPACK FOOTER //
// ./src/router/index.js